import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  state: {
    userId: "",
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    isUserActive: true,
    profilePicture: "",
    isViewer: false,
    dept: "",
    mgrUserId: "",
    mgrName: "",
    mgrEmail: "",
  },
};

export const userDetailsSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetail: (state, action) => {
      state.state = action.payload;
      delete state.state.password;
    },
  },
});

export const { setUserDetail } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
